<template>
  <div class="hotels-aside">
    <div class="page-links-vertical">
      <router-link
        v-for="item in links"
        :key="item.to"
        :to="item.to"
        :class="['page-links-vertical__item', { 'is-active': isActive(item.to) }]"
      >
        {{ item.label }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "HotelsSideMenu",

  computed: {
    hotelId() {
      return this.$route.params.id;
    },

    links() {
      const id = this.hotelId;

      return [
        { label: "Hotel Details", to: `/hotels/${id}/hotel` },
        { label: "Additional", to: `/hotels/${id}/additional` },
        { label: "Mobile Camps", to: `/hotels/${id}/mobile-camps` },
        { label: "Rooms", to: `/hotels/${id}/rooms` },
        { label: "Seasons", to: `/hotels/${id}/seasons` },
        { label: "Staff Accommodation", to: `/hotels/${id}/staff-accommodation` },
        { label: "Safety Measurements", to: `/hotels/${id}/safety-measurements` },
        { label: "Additional Prices", to: `/hotels/${id}/additional-prices` },
        { label: "Prices", to: `/hotels/${id}/prices` },
        { label: "Special Offers", to: `/hotels/${id}/offers` },
        { label: "Payment Policy", to: `/hotels/${id}/payment-policy` },
        { label: "Update History", to: `/hotels/${id}/history` }
      ];
    }
  },

  methods: {
    isActive(to) {
      return this.$route.path === to;
    }
  }
};
</script>
